import React from 'react';
import styled, { keyframes } from 'styled-components';
import Icon from './Icon';

const movingGradientAnimation = keyframes`
  0% { background-position: -250px 0; }
  100% { background-position: 250px 0; }
`;

const Skeleton = styled.div`
  height: 32px;
  width: 48px;
  background: var(--skeleton-gradient);
  background-size: 500px 100px;
  animation: ${movingGradientAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  border-radius: 6px;
`;

export default Skeleton;

const ImageWrapper = styled(Skeleton)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IconWrapper = styled(Icon)`
  color: var(--skeleton-icon);
`;

const BaseImageSkeleton = props => {
  return (
    <ImageWrapper {...props}>
      <IconWrapper icon="image" />
    </ImageWrapper>
  );
};

export const ImageSkeleton = styled(BaseImageSkeleton)``;

ImageSkeleton.displayName = 'ImageSkeleton';
